export default ({ app, context }, inject) => {
    const hyosec = {
        isHyosecTenant: function (){
            if(!app.$auth.user) return false;
            return app.$auth.user.email_office === 'hrss-admin@soc.pref.hyogo.jp'
        },
    }

    inject('hyosec', hyosec);
}